import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { EuiFlexGrid } from "@elastic/eui";
import TripSection from "../../shared/TripSection";
import PickupArrivalDetails from "./ArrivalDetails";
import PickupDepartureDetails from "./DepartureDetails";
import PickupDurationDetails from "./PickupDurationDetails";
import PickupAttachmentsDetails from "./AttachmentsDetails";
import PODNumberDetails from "./PODNumberDetails";
import ShipmentAmountDetails from "./ShipmentAmountDetails";
import ShipmentUnitDetails from "./ShipmentUnitDetails";
import { secondsToHoursAndMinutes } from "../../../../../utils/dateAndTime";

export default function PickupDetails({
    arrivalTimeOptions,
    arrivalTime,
    onArrivalTimeChange,
    isArrivalTimeEditable,
    departureTimeOptions,
    departureTime,
    onDepartureTimeChange,
    isDepartureTimeEditable,
    pickupDuration,
    attachmentsOptions,
    attachments,
    onAttachmentsChange,
    isAttachmentEditable,
    pickupName,
    podNumberOptions,
    podNumber,
    onPodNumberChange,
    isPodNumberEditable,
    shipmentAmountOptions,
    shipmentAmount,
    onShipmentAmountChange,
    isShipmentAmountEditable,
    shipmentUnitOptions,
    shipmentUnit,
    onShipmentUnitChange,
    isShipmentUnitEditable,
}) {
    const intl = useIntl();
    const arrivalTimeLabel = intl.formatMessage({ id: "trip.pickup-arrived-at" });
    const departureTimeLabel = intl.formatMessage({ id: "trip.pickup-left-at" });
    const durationLabel = intl.formatMessage({ id: "trip.pickup-duration" });
    const attachmentsLabel = intl.formatMessage({ id: "trip.pickup-attachment" });
    const podNumberLabel = intl.formatMessage({ id: "trip.pod-number" });
    const shipmentAmountLabel = intl.formatMessage({ id: "trip.shipment-number-of-units" });
    const shipmentUnitLabel = intl.formatMessage({ id: "trip.shipment-unit" });

    return (
        <TripSection
            headerTitle={<FormattedMessage id="trip.pickup-details-section-title" />}
            headerIconType="importAction"
        >
            <EuiFlexGrid
                columns={3}
                gutterSize="l"
            >
                <PickupArrivalDetails
                    label={arrivalTimeLabel}
                    options={arrivalTimeOptions}
                    time={arrivalTime}
                    onChange={onArrivalTimeChange}
                    isEditable={isArrivalTimeEditable}
                />

                <PickupDepartureDetails
                    label={departureTimeLabel}
                    options={departureTimeOptions}
                    time={departureTime}
                    onChange={onDepartureTimeChange}
                    isEditable={isDepartureTimeEditable}
                />

                <PickupDurationDetails
                    label={durationLabel}
                    duration={secondsToHoursAndMinutes(pickupDuration)}
                />

                <ShipmentAmountDetails
                    label={shipmentAmountLabel}
                    amount={shipmentAmount}
                    options={shipmentAmountOptions}
                    onChange={onShipmentAmountChange}
                    isEditable={isShipmentAmountEditable}
                />
                <ShipmentUnitDetails
                    label={shipmentUnitLabel}
                    options={shipmentUnitOptions}
                    unit={shipmentUnit}
                    onChange={onShipmentUnitChange}
                    isEditable={isShipmentUnitEditable}
                />

                <PickupAttachmentsDetails
                    label={attachmentsLabel}
                    options={attachmentsOptions}
                    attachments={attachments}
                    onChange={onAttachmentsChange}
                    isEditable={isAttachmentEditable}
                    pickupName={pickupName}
                />
                <PODNumberDetails
                    label={podNumberLabel}
                    options={podNumberOptions}
                    podNumber={podNumber}
                    onChange={onPodNumberChange}
                    isEditable={isPodNumberEditable}
                    pickupName={pickupName}
                />
            </EuiFlexGrid>
        </TripSection>
    );
}
